export namespace DateTime {

    export type DayTimeframe = {
        /**
         * Start of the timeframe in seconds from the midnight
         */
        begin: number;
        /**
         * End of the timeframe in seconds from the midnight
         */
        end: number;
    };

    export type WeekSchedule = {
        /** Day of week, 0 is Sunday, 6 is Saturday */
        [dayNumber in WEEKDAY]?: DayTimeframe[]
    };

    export enum WEEKDAY {
        sunday = 0,
        monday = 1,
        tuesday = 2,
        wednesday = 3,
        thursday = 4,
        friday = 5,
        saturday = 6,
    }

    export enum WEEKDAY_NAME {
        sunday = 'sunday',
        monday = 'monday',
        tuesday = 'tuesday',
        wednesday = 'wednesday',
        thursday = 'thursday',
        friday = 'friday',
        saturday = 'saturday',
    }

    export const WEEKDAY_NAMES_LIST = Object.values(WEEKDAY_NAME) as WEEKDAY_NAME[];
}

/** @deprecated Use DateTime.WEEKDAY */
export import WEEKDAY = DateTime.WEEKDAY;
/** @deprecated Use DateTime.WEEKDAY_NAME */
export import WEEKDAY_NAME = DateTime.WEEKDAY_NAME;
/** @deprecated Use DateTime.WEEKDAY_NAMES_LIST */
export import WEEKDAY_NAMES_LIST = DateTime.WEEKDAY_NAMES_LIST;
